// extracted by mini-css-extract-plugin
var _1 = "ModalLoader-moduleModalLoaderMask__VHndG Mask-moduleMask__Puct6";
var _2 = "ModalLoader-modulemodalLoader__ViHPK Loader-moduleLoader__Q8joA";
export { _1 as "ModalLoaderMask", _2 as "modalLoader" }
